import { render, staticRenderFns } from "./approval_table.vue?vue&type=template&id=0c3f3aac&scoped=true"
import script from "./approval_table.vue?vue&type=script&lang=js"
export * from "./approval_table.vue?vue&type=script&lang=js"
import style0 from "./approval_table.vue?vue&type=style&index=0&id=0c3f3aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f3aac",
  null
  
)

export default component.exports